export enum ScraperTypeEnum {
  GENERIC = 'generic',
  UPPSALA = 'uppsala',
}
